import Vue from "vue";
import Vuex from "vuex";
import { i18n } from "../translations/i18n";
import { router } from '../main.js'

import { getCardsFromResponse, getCardsFromResponseNew, isSameCard, getStorableBookmarks, arrayMove } from './helpers'
import * as http from './http';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        themePath: '/o/yja-sammio-theme/',
        search: {
            visibleCards: [],
            meta: {
                total: 0,
                pageSize: 10,
                start: 0
            },
            currentPage: 1
        },
        filters: {
            active: {
                categories: [[],[]]
            }
        },
        filtersReady: false,
        isMobile: false,
        portletId: '',
        isLoading: false,
        loadStatus: false,
        showLoader: false,
        errors: {
            hasErrors: false,
            data: []
        },
        bookmarks: {
            cards: [],
            name: '',
            shortUrl: '',
            reorderActive: false,
            activeBookmark: null
        },
        singleCardView: null,
        attachment: null,
    },
    mutations: {
        ADD_VISIBLE_CARD: (state, payload) => {
            const cards = [...state.search.visibleCards]
            let index = payload.index
            if (payload.type !== 'act') {
                index = index + 1
            }
            const alreadyVisible = cards.filter(card => isSameCard(card, payload.card))
            if (alreadyVisible.length === 0) {
                cards.splice(index, 0, payload.card);
                Vue.set(state.search, 'visibleCards', cards);
            }
        },
        ADD_BOOKMARKS: (state, payload) => {
            const currentBookmarks = [...state.bookmarks.cards]
            let index = payload.index
            if ((typeof index === 'number') && (payload.type !== 'act')) {
                index = index + 1
            }
            if (!payload.hasOwnProperty('cards')) {
                payload.cards = [payload.card]
            }
            for (const bookmark of payload.cards) {
                const isBookmarked = currentBookmarks.filter(card => isSameCard(card, bookmark)).length > 0
                if (!isBookmarked) {
                    if (typeof index === 'number') {
                        currentBookmarks.splice(index, 0, bookmark)
                    } else {
                        currentBookmarks.push(bookmark);
                    }
                }
            }
            Vue.set(state.bookmarks, 'shortUrl', '')
            Vue.set(state.bookmarks, 'cards', currentBookmarks);
        },
        REMOVE_BOOKMARK: (state, payload) => {
            const currentBookmarks = [...state.bookmarks.cards]
            const newBookmarks = currentBookmarks.filter(card => !isSameCard(card, payload.card))
            if (currentBookmarks.length !== newBookmarks.length) {
                Vue.set(state.bookmarks, 'shortUrl', '')
                Vue.set(state.bookmarks, 'cards', newBookmarks);
            }
        },
        CLEAR_BOOKMARKS: (state) => {
            Vue.set(state.bookmarks, 'shortUrl', '')
            Vue.set(state.bookmarks, 'cards', []);
        },
        UPDATE_BOOKMARK_NAME: (state, payload) => {
            Vue.set(state.bookmarks, 'shortUrl', '')
            Vue.set(state.bookmarks, 'name', payload.name)
        },
        UPDATE_BOOKMARK_CONTENT_VISIBILITY: (state, payload) => {
            const currentBookmarks = [...state.bookmarks.cards]
            if (typeof payload.index === 'undefined') {
                for (let card of currentBookmarks) {
                    card[payload.type + 'Visible'] = payload.value
                }
            } else if ((typeof currentBookmarks[payload.index] !== 'undefined')) {
                currentBookmarks[payload.index][payload.type + 'Visible'] = payload.value
            }
            Vue.set(state.bookmarks, 'shortUrl', '')
            Vue.set(state.bookmarks, 'cards', currentBookmarks)
        },
        UPDATE_BOOKMARK_GUIDANCE_HEADINGS_VISIBILITY: (state, payload) => {
            const currentBookmarks = [...state.bookmarks.cards]
            if (typeof payload.index === 'undefined') {
                for (let card of currentBookmarks) {
                    card.hiddenGuidanceHeadingIndices = payload.value
                }
            } else if ((typeof currentBookmarks[payload.index] !== 'undefined')) {
                currentBookmarks[payload.index].hiddenGuidanceHeadingIndices = payload.value
            }
            Vue.set(state.bookmarks, 'shortUrl', '')
            Vue.set(state.bookmarks, 'cards', currentBookmarks)
        },
        UPDATE_BOOKMARKS_SHORT_URL: (state, shortUrl) => {
            if ((typeof shortUrl !== 'undefined') && (shortUrl !== '')) {
                Vue.set(state.bookmarks, 'shortUrl', shortUrl)
            }
        },
        SET_BOOKMARK_STATUS: (state, bookmark) => {
            const currentActiveBookmark = state.bookmarks.activeBookmark;

            // If bookmark is missing or activated second time, reset activeBookmark
            if (!bookmark || currentActiveBookmark == bookmark) {
                Vue.set(state.bookmarks, 'activeBookmark', null);
            } else {
                Vue.set(state.bookmarks, 'activeBookmark', bookmark)
            }
        },
        MOVE_BOOKMARK: (state, payload) => {
            const bookmarkKey = payload.bookmarkKey;
            const direction = payload.direction;

            var bookmarks = state.bookmarks.cards;

            const sameBookmark = (bookmark) => bookmark.key == bookmarkKey;
            const indexOfBookmark = bookmarks.findIndex(sameBookmark)

            if (bookmarkKey) {
                if (bookmarks.length > 1) {

                    if (direction == "down") {
                        // Check if other item exists after current bookmark
                        if (typeof bookmarks[indexOfBookmark + 1] !== 'undefined') {
                            bookmarks = arrayMove(bookmarks, indexOfBookmark, indexOfBookmark + 1);
                        }
                    }
                    if (direction == "up") {
                        // Check if other item exists before current bookmark
                        if (typeof bookmarks[indexOfBookmark - 1] !== 'undefined') {
                            bookmarks = arrayMove(bookmarks, indexOfBookmark, indexOfBookmark - 1);
                        }
                    }
                }
            } else {
                console.log("bookmarkKey not found")
            }
            Vue.set(state.bookmarks, 'cards', bookmarks)
        },
        SET_BOOKMARKS_REORDER_ACTIVE: (state, isActive) => {
            Vue.set(state.bookmarks, 'reorderActive', isActive)
        },
        SET_VISIBLE_CARDS: (state, visibleCards) => {
            Vue.set(state.search, 'visibleCards', [...visibleCards]);
        },
        UPDATE_SEARCH_RESULT_META: (state, meta) => {
            Vue.set(state.search, 'meta', meta);
        },
        SET_SEARCH_CURRENT_PAGE: (state, page) => {
            Vue.set(state.search, 'currentPage', page)
        },
        INIT_FILTERS: (state, filters) => {
            Vue.set(state, 'filters', filters);
            Vue.set(state, 'filtersReady', true);
        },
        INIT_PORTLET_ID: (state, portletId) => {
            Vue.set(state, 'portletId', portletId)
        },
        UPDATE_ACTIVE_TYPES: (state, categoryIds) => {
            Vue.set(state.filters.active, 'types', categoryIds)
        },
        UPDATE_ACTIVE_CARD_FIELDS: (state, cardFields) => {
            Vue.set(state.filters.active, 'cardFields', cardFields)
        },
        UPDATE_ACTIVE_CATEGORIES: (state, categoryIds) => {
            Vue.set(state.filters.active, 'categories', categoryIds)
        },
        REMOVE_ACTIVE_CATEGORY: (state, removedCategoryId) => {
            let activeCategories = []
            for (let i = 0; i < state.filters.active.categories.length; i++) {
                const categories = state.filters.active.categories[i]
                let subCategories = []
                for (let j = 0; j < categories.length; j++) {
                    const categoryId = categories[j]
                    if (categoryId !== removedCategoryId) {
                        subCategories.push(categoryId)
                    }
                }
                activeCategories.push(subCategories)
            }
            Vue.set(state.filters.active, 'categories', activeCategories)
        },
        UPDATE_Q: (state, q) => {
            Vue.set(state.filters.active, 'q', q)
        },
        SET_IS_MOBILE: (state, status) => {
            Vue.set(state, 'isMobile', status)
        },
        CLEAR_ALL_FILTERS: (state) => {
            Vue.set(state.filters.active, 'categories', [[],[]])
        },
        SET_LOADING_STATUS: (state, status) => {
           Vue.set(state, 'isLoading', status)
        },
        SET_LOADER_STATUS: (state, status) => {
          Vue.set(state,'showLoader', status)
        },
        SET_LOAD_STATUS: (state, status) => {
            Vue.set(state,'loadStatus', status)
        },
        SET_ERROR_MESSAGES: (state, response) => {
            Vue.set(state.errors, 'hasErrors', response.hasErrors)
            state.errors.data.push(response.data)
        },
        SET_SINGLE_CARD_VIEW: (state, singleCardView) => {
            Vue.set(state,'singleCardView', singleCardView)
        },
        SET_ATTACHMENT: (state, attachment) => {
            Vue.set(state,'attachment', attachment)
        },
        CLEAR_SINGLE_CARD_VIEW: (state) => {
            Vue.set(state, 'singleCardView', null)
        }
    },
    actions: {
        addVisibleCard: ({commit}, payload) => {
            commit('ADD_VISIBLE_CARD', payload)
        },
        addBookmark: ({commit}, payload) => {
            commit('ADD_BOOKMARKS', payload)
        },
        addAllBookmarks: ({commit, state}) => {
            let params = state.filters.active
            params.start = 0
            params.pageSize = 300
            http.get('/get-search-results', state.portletId, params)
                .then(response => {
                    const cards = getCardsFromResponse(response.data.subsections)
                    commit('ADD_BOOKMARKS', { cards: cards })
                })
                .catch(error => {
                    dispatch('setErrorMessages', { hasErrors: true, data: { type: 'cards', code: '', text: i18n.t('sammio.errors.common_error') } })
                })
        },
        removeBookmark: ({commit}, payload) => {
            commit('REMOVE_BOOKMARK', payload)
        },
        setBookmarkStatus: ({commit}, payload) => {
            commit('SET_BOOKMARK_STATUS', payload.bookmark)
        },
        moveBookmark: ({commit}, payload) => {
            commit('MOVE_BOOKMARK', payload);
        },
        setBookmarks: ({commit, dispatch}, payload) => {
            dispatch('clearBookmarks')
            dispatch('addBookmark', payload)
        },
        clearBookmarks: ({commit}) => {
            commit('CLEAR_BOOKMARKS')
        },
        updateBookmarkName: ({ commit}, payload) => {
            commit('UPDATE_BOOKMARK_NAME', payload)
        },
        updateBookmarkContentVisibility: ( { commit }, payload) => {
            commit('UPDATE_BOOKMARK_CONTENT_VISIBILITY', payload)
        },
        updateBookmarkGuidanceHeadingsVisibility: ( { commit }, payload) => {
            commit('UPDATE_BOOKMARK_GUIDANCE_HEADINGS_VISIBILITY', payload)
        },
        saveBookmarks: ( { commit, state, getters, dispatch } ) => {
            const data = getStorableBookmarks(getters.getBookmarks)
            http.post('/save-bookmarks', state.portletId, data)
                .then(response => {
                    commit('UPDATE_BOOKMARKS_SHORT_URL', response.data.shortUrl)
                })
                .catch(error => {
                    this.error = true
                    dispatch('setErrorMessages', { hasErrors: true, data: { type: 'bookmarks', code: '', text: i18n.t('sammio.errors.common_error') } })
                })
        },
        loadBookmarks: ({ commit, state, dispatch }, payload) => {
            http.get('/load-bookmarks', state.portletId, payload)
                .then(response => {
                    const cards = getCardsFromResponse(response.data.subsections)
                    commit('ADD_BOOKMARKS', { cards: cards })
                    commit('UPDATE_BOOKMARKS_SHORT_URL', payload.shortUrl)
                })
                .catch(error => {
                    this.error = true
                    dispatch('setErrorMessages', { hasErrors: true, data: { type: 'bookmarks', code: '', text: i18n.t('sammio.errors.common_error') } })
                })
        },
        setBookmarksReorderActive: ( { commit }, payload) => {
            commit('SET_BOOKMARKS_REORDER_ACTIVE', payload.active)
        },
        fetchCards: ({commit, state, dispatch}, page) => {
            if (!page) {
                page = 0
            }
            const start = Math.max(0, page * state.search.meta.pageSize)
            let params = {}
            let urlPath = ''
            if (state.singleCardView !== null) {
                urlPath = '/get-subsection'
                params = state.singleCardView
            } else {
                // clear url from containing indices for single card view
                if ((router.currentRoute.name.startsWith('search')) && (router.currentRoute.path !== '/')) {
                    router.push('/')
                }
                urlPath = '/get-search-results'
                params = state.filters.active
                params.start = start
            }

            http.get(urlPath, state.portletId, params)
                .then(response => {
                    if (!response.data.hasOwnProperty('subsections')) {
                        response.data['subsections'] = [response.data.subsection]
                    }
                    commit('SET_VISIBLE_CARDS', getCardsFromResponseNew(response.data.subsections,state.filters.active.q))
                    commit('UPDATE_SEARCH_RESULT_META', response.data.meta)
                    commit('SET_LOADING_STATUS', true)
                    commit('CLEAR_SINGLE_CARD_VIEW')
                })
                .catch(error => {
                    dispatch('setErrorMessages', { hasErrors: true, data: { type: 'cards', code: '', text: i18n.t('sammio.errors.common_error') } })
                })
        },
        setSingleCardView: ( { commit }, payload) => {
            commit('SET_SINGLE_CARD_VIEW', payload)
        },
        clearSingleCardView: ( { commit }) => {
            commit('CLEAR_SINGLE_CARD_VIEW')
        },
        setSearchCurrentPage: ( { commit }, payload) => {
            commit('SET_SEARCH_CURRENT_PAGE', payload.page)
        },
        initFilters: ({ commit, state, dispatch }) => {
            http.get('/get-filters', state.portletId)
                .then(response => {
                    commit('INIT_FILTERS', response.data)
                    commit('SET_LOADING_STATUS', true)
                })
                .catch(error => {
                    dispatch('setErrorMessages', { hasErrors: true, data: { type: 'filters', code: '', text: i18n.t('sammio.errors.common_error') } })
                })
        },
        initPortletId: ({commit}, portletId) => {
            commit('INIT_PORTLET_ID', portletId)
        },
        updateActiveTypes: ({commit}, categoryIds) => {
            commit('UPDATE_ACTIVE_TYPES', categoryIds)
        },
        updateActiveCardFields: ({commit}, cardFields) => {
            commit('UPDATE_ACTIVE_CARD_FIELDS', cardFields)
        },
        updateActiveCategories: ({commit}, categoryIds) => {
            commit('UPDATE_ACTIVE_CATEGORIES', categoryIds)
        },
        deactivateFilter: ({commit, dispatch}, categoryId) => {
            commit('REMOVE_ACTIVE_CATEGORY', categoryId)
            dispatch('fetchCards')
        },
        updateQ: ({commit}, q) => {
            commit('UPDATE_Q', q)
        },
        setIsMobile: ({commit}, status) => {
            commit('SET_IS_MOBILE', status)
        },
        clearAllFilters: ({commit, dispatch}) => {
            commit('CLEAR_ALL_FILTERS')
            dispatch('fetchCards')
        },
        setLoadingState: ({commit}, status) => commit('SET_LOADING_STATUS', status),
        setLoaderState: ({commit}, status) => commit('SET_LOADER_STATUS', status),
        setLoadStatus: ({commit}, status) => commit('SET_LOAD_STATUS', status),
        setErrorMessages: ({commit}, payload) => commit('SET_ERROR_MESSAGES', payload)
    },
    getters: {
        getIsMobile: state => state.isMobile,
        getErrors:  state => state.errors,
        getLoadingState: state => state.isLoading,
        getBookmarks: state => state.bookmarks.cards,
        getActiveBookmark: state => state.bookmarks.activeBookmark,
        getBookmarkName: state => state.bookmarks.name,
        getBookmarksShortUrl: state => state.bookmarks.shortUrl,
        getBookmarksReorderActive: state => state.bookmarks.reorderActive,
        getFilterLabels: state => state.filters.labels,
        getFilterVocabularies: state => state.filters.vocabularies,
        getFiltersReady: state => state.filtersReady,
        getFilters: state => state.filters,
        getActiveFilters: state => state.filters.active,
        getVisibleCards: state => state.search.visibleCards,
        getSearchMeta: state => state.search.meta,
        getSearchCurrentPage: state => state.search.currentPage,
        getIsLoading: state => state.isLoading,
        getLoaderStatus: state => state.showLoader,
        getLoadStatus: state => state.loadingDone
    }
})

